import html2pdf from 'html2pdf.js';
import moment from 'moment';

/**
 * 流式生成报告 + 复制 Markdown + 导出 PDF（依赖 $refs.reportPanel、userText、aiText、result、ai_executings）
 * 流式请求统一走 AI.chat（见 vue-plugins/api.js），避免 this.$ai 被 AiBot 覆盖后无法调用。
 */
export default {
  methods: {
    async CreateByAI() {
      if (!this.aiText || this.aiText.length < 10) {
        this.Error('请先获取数据');
        return;
      }
      if (this.aiText.length > 200000) {
        this.Error('原始数据过长（暂建议 200000 字以内），请缩小范围或拆分处理');
        return;
      }
      this.ai_executings = true;
      this.result = '';
      const decoder = new TextDecoder();
      try {
        if (typeof this.$ai.chat !== 'function') {
          throw new Error('AI.chat 未就绪');
        }
        const reader = await this.$ai.chat({
          model_id: 'deepseek-v3',
          messages: [
            {
              role: 'user',
              content: `${this.userText || ''}\n\n${this.aiText}`,
            },
          ],
          stream: true,
          value_type: 'text',
        });
        if (!reader || typeof reader.read !== 'function') {
          throw new Error('未能建立流式连接');
        }
        let out = '';
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }
          if (value) {
            const chunk = value instanceof Uint8Array
              ? decoder.decode(value, { stream: true })
              : String(value);
            out += chunk;
            this.result = out;
            this.$nextTick(() => {
              if (this.$refs.reportPanel && this.$refs.reportPanel.scrollToBottom) {
                this.$refs.reportPanel.scrollToBottom();
              }
            });
          }
        }
      } catch (e) {
        console.error(e);
        this.Error(e && e.message ? e.message : e);
      } finally {
        this.ai_executings = false;
      }
    },
    async copyReportMd() {
      if (!this.result) {
        return;
      }
      await this._zzlCopyText(this.result, '已复制报告 Markdown');
    },
    /** 复制左侧清洗数据中的图片 URL 列表（名称 + 链接），依赖 this.images */
    async copyImageAddresses() {
      const imgs = this.images || [];
      if (!imgs.length) {
        this.Error('暂无图片地址');
        return;
      }
      const lines = imgs.map((item, i) => {
        const url = typeof item === 'string'
          ? item
          : (item && (item.url || item.href)) || '';
        const name = (item && item.name) ? String(item.name) : `图片${i + 1}`;
        return `${name}\t${url}`;
      });
      await this._zzlCopyText(lines.join('\n'), '已复制图片名称与地址');
    },
    exportPDF() {
      if (!this.result) {
        return;
      }
      const stem = typeof this.zzlReportPdfStem === 'function'
        ? this.zzlReportPdfStem()
        : `export_${moment().format('YYYYMMDD')}`;
      const opt = {
        margin: 1,
        filename: `${stem}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      };
      const el = this.$refs.reportPanel && this.$refs.reportPanel.getPdfElement
        ? this.$refs.reportPanel.getPdfElement()
        : null;
      if (el) {
        html2pdf().set(opt).from(el).save();
      }
    },
    async _zzlCopyText(text, okMsg) {
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const ok = document.execCommand('copy');
          document.body.removeChild(textarea);
          if (!ok) {
            throw new Error('copy failed');
          }
        }
        this.Success(okMsg || '复制成功');
      } catch (err) {
        console.error(err);
        this.Error('复制失败');
      }
    },
  },
};
